var map = {
	"./add_col_after.svg": "f8d2",
	"./add_col_before.svg": "f796",
	"./add_row_after.svg": "1ec7",
	"./add_row_before.svg": "3680",
	"./bold.svg": "4948",
	"./checklist.svg": "34e3",
	"./code.svg": "38b3",
	"./code_single.svg": "15b7",
	"./combine_cells.svg": "0941",
	"./delete_col.svg": "389f",
	"./delete_row.svg": "d9b1",
	"./delete_table.svg": "731f",
	"./github.svg": "f5e5",
	"./hr.svg": "2e61",
	"./image.svg": "f75e",
	"./italic.svg": "6c23",
	"./link.svg": "174a",
	"./mention.svg": "ed2a",
	"./ol.svg": "bc39",
	"./paragraph.svg": "8dc6",
	"./quote.svg": "d67d",
	"./redo.svg": "c474",
	"./remove.svg": "4aba",
	"./sign_out.svg": "7bf5",
	"./strike.svg": "e043",
	"./table.svg": "9e2e",
	"./ul.svg": "2302",
	"./underline.svg": "e3ca",
	"./undo.svg": "5e4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19de";